import { connect } from 'react-redux';

import { IAppState } from '../../../store';
import { IOwnProps, IAppStateProps, UserInfo } from './index';

export const UserInfoContainer = connect<IAppStateProps, {}, IOwnProps, IAppState>((state: IAppState) => ({
  userIsAuthenticated: state.user.isAuthenticated,
}))(UserInfo);
